(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nytc-deluxe-vs-pro"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    function wire(form){
      if(form.dataset.bound)return; form.dataset.bound='1';
      var card=form.closest('[data-nvp-card]'),btn=form.querySelector('[data-nvp-add]'),label=form.querySelector('[data-nvp-label]'),done=form.querySelector('[data-nvp-done]'),status=form.querySelector('[data-nvp-status]');
      function curId(){var c=form.querySelector('input[name="id"]:checked')||form.querySelector('input[name="id"]');return Number(c.value);}
      var busy=false;
      function paint(){card.classList.add('is-added');label.textContent='✓ Added · Add another';done.hidden=false;}
      fetch(root+'cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(c){var id=curId();if(c.items.some(function(i){return i.variant_id===id}))paint();}).catch(function(){});
      form.addEventListener('submit',function(ev){
        ev.preventDefault(); if(busy||btn.disabled)return; busy=true; btn.disabled=true; status.textContent='';
        var props={}; new FormData(form).forEach(function(v,k){var m=k.match(/^properties\[(.+)\]$/);if(m)props[m[1]]=v;});
        fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:curId(),quantity:1,properties:props}]})})
        .then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message||'Could not add. Please try again.');return j;})})
        .then(function(){paint();try{document.dispatchEvent(new CustomEvent('cart:build'));document.dispatchEvent(new CustomEvent('cart:updated'));}catch(e){}var o=document.querySelector('.js-drawer-open-cart');setTimeout(function(){if(o)o.click();},50);})
        .catch(function(e){status.textContent=e.message||'Could not add. Please try again.';})
        .then(function(){busy=false;btn.disabled=false;});
      });
    }
    function init(){
      document.querySelectorAll('[data-nvp-form]').forEach(wire);
      document.querySelectorAll('[data-nvp-scrolltop]').forEach(function(b){if(b.dataset.bound)return;b.dataset.bound='1';b.addEventListener('click',function(){var t=document.querySelector('[data-nb-form="deluxe"] [data-nb-add], .ndr-submit, form[action*="/cart/add"] [name="add"]');if(t){t.scrollIntoView({behavior:'smooth',block:'center'});setTimeout(function(){t.focus();},500);}else{window.scrollTo({top:0,behavior:'smooth'});}});});
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
    document.addEventListener('shopify:section:load',init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nytc-og-bullet-upgrade"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    function wire(sec){
      if(sec.dataset.bound)return; sec.dataset.bound='1';
      var btn=sec.querySelector('[data-nytc-ogb-add]'),label=btn.querySelector('[data-label]'),done=sec.querySelector('[data-nytc-ogb-done]'),status=sec.querySelector('[data-nytc-ogb-status]');
      var id=Number(sec.dataset.variant),busy=false;
      function paintAdded(){sec.classList.add('is-added');label.textContent='✓ Added · Add another';done.hidden=false;}
      fetch(root+'cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(c){if(c.items.some(function(i){return i.variant_id===id}))paintAdded();}).catch(function(){});
      btn.addEventListener('click',function(){
        if(busy)return; busy=true; btn.disabled=true; status.textContent='';
        fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
        .then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message||'Could not add. Please try again.');return j;})})
        .then(function(){
          paintAdded();
          try{document.dispatchEvent(new CustomEvent('cart:build'));document.dispatchEvent(new CustomEvent('cart:updated'));}catch(e){}
          var opener=document.querySelector('.js-drawer-open-cart');
          setTimeout(function(){ if(opener)opener.click(); },50);
        })
        .catch(function(e){status.textContent=e.message||'Could not add. Please try again.';})
        .then(function(){busy=false;btn.disabled=false;});
      });
    }
    function init(){document.querySelectorAll('[data-nytc-ogb]').forEach(wire);}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
    document.addEventListener('shopify:section:load',init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nytc-pump-stock"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nytc-pump-stock')) {
    customElements.define('nytc-pump-stock', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-thumb]');
          if (!button || !this.contains(button)) return;
          this.querySelectorAll('[data-photo]').forEach(photo => { photo.hidden = photo.dataset.photo !== button.dataset.thumb; });
          this.querySelectorAll('[data-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
        });
        const chips = this.querySelectorAll('.nps__chip-input');
        if (!chips.length) return;
        chips.forEach(chip => chip.addEventListener('change', () => this.applyVariant(chip)));
      }
      applyVariant(option) {
        const ready = this.dataset.purchaseReady === 'true';
        const available = option.dataset.available === 'true' && ready;
        const previewStock = Number(this.dataset.previewStock || 0);
        const showStock = available || (previewStock > 0 && option.dataset.available !== 'true');
        const hidden = this.querySelector('[data-variant-id]');
        if (hidden) hidden.value = option.value;
        this.querySelector('[data-stock]').textContent = showStock ? this.dataset.limited : this.dataset.sold;
        this.querySelectorAll('[data-table-stock]').forEach(el => { el.textContent = showStock ? this.dataset.limited : this.dataset.sold; });
        this.querySelectorAll('[data-price]').forEach(el => { el.textContent = option.dataset.price; });
        this.querySelectorAll('[data-upgrade-price]').forEach(el => { el.textContent = option.dataset.upgradePrice; });
        this.querySelectorAll('[data-upgrade-link]').forEach(el => { if (option.dataset.upgradeUrl) el.href = option.dataset.upgradeUrl; });
        this.querySelectorAll('[data-difference-label]').forEach(el => {
          el.hidden = !(Number(option.dataset.difference) > 0);
          el.textContent = 'Upgrade for ' + option.dataset.differenceMoney + ' more';
        });
        const saving = Number(option.dataset.saving) > 0;
        this.querySelectorAll('[data-regular]').forEach(el => { el.hidden = !saving; el.innerHTML = '<s>' + option.dataset.regular + '</s>'; });
        this.querySelectorAll('[data-save]').forEach(el => { el.hidden = !saving; el.textContent = 'Save ' + option.dataset.savingMoney; });
        const ship = this.querySelector('[data-free-ship-note]');
        if (ship) ship.hidden = !(Number(option.dataset.rawPrice) >= Number(this.dataset.freeShip));
        const submit = this.querySelector('[data-add-button]');
        submit.disabled = !available;
        submit.textContent = available ? this.dataset.add : this.dataset.sold;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nytc-pump2-bridge"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    function wireForm(form){
      if(form.dataset.bound)return; form.dataset.bound='1';
      var btn=form.querySelector('[data-nb-add]'),label=form.querySelector('[data-nb-label]'),done=form.querySelector('[data-nb-done]'),status=form.querySelector('[data-nb-status]');
      var card=form.closest('[data-nb-kit]')||form.closest('.nb__buy');
      var busy=false;
      function currentId(){var r=form.querySelector('input[name="id"]:checked');if(r)return Number(r.value);var h=form.querySelector('input[name="id"]');return h?Number(h.value):0;}
      function paintAdded(){card&&card.classList.add('is-added');if(label)label.textContent='✓ Added · Add another';if(done)done.hidden=false;}
      fetch(root+'cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(c){var id=currentId();if(c.items.some(function(i){return i.variant_id===id}))paintAdded();}).catch(function(){});
      form.querySelectorAll('input[name="id"][type="radio"]').forEach(function(r){r.addEventListener('change',function(){var p=r.dataset.price;var el=form.querySelector('[data-nb-kit-btnprice]');if(el&&p)el.textContent=p;var top=card&&card.querySelector('[data-nb-kit-price]');if(top&&p)top.textContent=p;});});
      form.addEventListener('submit',function(ev){
        ev.preventDefault(); if(busy||!btn||btn.disabled)return; busy=true; btn.disabled=true; if(status)status.textContent='';
        var fd=new FormData(form); var props={};
        fd.forEach(function(v,k){var m=k.match(/^properties\[(.+)\]$/);if(m)props[m[1]]=v;});
        var body={items:[{id:currentId(),quantity:1,properties:props}]};
        fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
        .then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message||'Could not add. Please try again.');return j;})})
        .then(function(){
          paintAdded();
          try{document.dispatchEvent(new CustomEvent('cart:build'));document.dispatchEvent(new CustomEvent('cart:updated'));}catch(e){}
          var opener=document.querySelector('.js-drawer-open-cart');
          setTimeout(function(){ if(opener)opener.click(); },50);
        })
        .catch(function(e){if(status)status.textContent=e.message||'Could not add. Please try again.';})
        .then(function(){busy=false;btn.disabled=false;});
      });
    }
    function wireGallery(g){
      if(g.dataset.bound)return; g.dataset.bound='1';
      var track=g.querySelector('[data-nb-track]'),dots=g.querySelectorAll('[data-nb-dots] i');
      if(!track||!dots.length)return;
      var t;
      track.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){var i=Math.round(track.scrollLeft/track.clientWidth);dots.forEach(function(d,n){d.classList.toggle('is-on',n===i);});},60);},{passive:true});
    }
    function wireSticky(sec){
      var bar=sec.querySelector('[data-nb-sticky]'),hero=sec.querySelector('[data-nb-form="'+(sec.dataset.mode||'deluxe')+'"] [data-nb-add]');
      if(!bar||!hero)return;
      if(!('IntersectionObserver' in window))return;
      var io=new IntersectionObserver(function(es){es.forEach(function(e){var off=!e.isIntersecting&&e.boundingClientRect.top<0;bar.hidden=!off;document.documentElement.classList.toggle('nytc-float-on',off);});},{threshold:0});
      io.observe(hero);
      sec.querySelectorAll('[data-nb-scroll]').forEach(function(b){b.addEventListener('click',function(){hero.scrollIntoView({behavior:'smooth',block:'center'});setTimeout(function(){hero.focus();},500);});});
    }
    function wireSolo(f){if(f.dataset.b)return;f.dataset.b=1;f.addEventListener('submit',function(e){e.preventDefault();var b=f.querySelector('button');b.disabled=true;var props={};new FormData(f).forEach(function(v,k){var m=k.match(/^properties\[(.+)\]$/);if(m)props[m[1]]=v;});fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(f.querySelector('[name=id]').value),quantity:1,properties:props}]})}).then(function(r){if(!r.ok)throw 0;f.querySelector('.nb__solodone').hidden=false;try{document.dispatchEvent(new CustomEvent('cart:build'));document.dispatchEvent(new CustomEvent('cart:updated'));}catch(x){}var o=document.querySelector('.js-drawer-open-cart');if(o)o.click();}).catch(function(){}).then(function(){b.disabled=false;});});}
    function init(){
      document.querySelectorAll('.nb__soloform').forEach(wireSolo);
      document.querySelectorAll('[data-nytc-bridge]').forEach(function(sec){
        sec.querySelectorAll('[data-nb-form]').forEach(wireForm);
        sec.querySelectorAll('[data-nb-gallery]').forEach(wireGallery);
        if(!sec.dataset.stickyBound){sec.dataset.stickyBound='1';wireSticky(sec);}
      });
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
    document.addEventListener('shopify:section:load',init);
  })();

  } catch(e) { console.error(e); }
})();
})();
